module.exports = __webpack_public_path__ + "static/img/kedu.7934e8c8.png";